import React, { useState } from "react";
import BreadCrumb from "Common/BreadCrumb";

import useJobs from "hooks/useJobs";
import { JobCard } from "Common/Components/JobCard";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useJobStats from "hooks/useJobStats";

const Jobs = () => {
  const [status, setStatus] = useState("");
  const { data, isLoading, hasNextPage, handleEndReached } = useJobs(
    10,
    status
  );

  const { data: stats } = useJobStats();

  const navigation = useNavigate();

  const handleCreateJob = () => {
    navigation("/create-job");
  };

  const handleFilter = (status: string) => {
    setStatus(status);
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Jobs" pageTitle="Jobs" />
      <div className="flex flex-col">
        <button
          onClick={handleCreateJob}
          type="button"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors w-fit self-end my-6"
        >
          <Plus className="inline-block size-4" />{" "}
          <span className="align-middle">Create Job</span>
        </button>
        <div className="w-full rounded-md grid grid-cols-2 lg:grid-cols-5 mb-4 gap-3">
          <button
            onClick={() => handleFilter("")}
            className="flex flex-col gap-1 items-start text-left shadow-sm rounded-md p-3 lg:p-4 lg:px-8 bg-white"
          >
            <span className=" font-bold text-lg">
              {stats?.data?.total ?? 0}
            </span>
            <span className=" text-sm text-gray-400">Total jobs</span>
          </button>
          <button
            onClick={() => handleFilter("pending")}
            className="flex flex-col gap-1 items-start text-left shadow-sm rounded-md p-3 lg:p-4 lg:px-8 bg-white"
          >
            <span className=" font-bold text-lg">
              {stats?.data?.pending ?? 0}
            </span>
            <span className=" text-sm text-gray-400">Pending Approval</span>
          </button>

          <button
            onClick={() => handleFilter("approved")}
            className="flex flex-col gap-1 items-start text-left shadow-sm rounded-md p-3 lg:p-4 lg:px-8 bg-white"
          >
            <span className=" font-bold text-lg">
              {stats?.data?.approved ?? 0}
            </span>
            <span className=" text-sm text-gray-400">Approved jobs</span>
          </button>

          <button
            onClick={() => handleFilter("suspended")}
            className="flex flex-col gap-1 items-start text-left shadow-sm rounded-md p-3 lg:p-4 lg:px-8 bg-white"
          >
            <span className=" font-bold text-lg">
              {stats?.data?.suspended ?? 0}
            </span>
            <span className=" text-sm text-gray-400">Suspended jobs</span>
          </button>

          <button
            onClick={() => handleFilter("declined")}
            className="flex flex-col gap-1 items-start text-left shadow-sm rounded-md p-3 lg:p-4 lg:px-8 bg-white"
          >
            <span className=" font-bold text-lg">
              {stats?.data?.declined ?? 0}
            </span>
            <span className=" text-sm text-gray-400">Declined jobs</span>
          </button>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center">
            <p>Loading...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
            <div className="xl:col-span-12">
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" id="usersTable">
                <div className="overflow-x-auto">
                  {data && data?.length! > 0 ? (
                    <div className=" flex flex-col lg:flex-row justify-stretch items-center gap-4 flex-wrap">
                      {data?.map((data) => (
                        <div
                          key={data._id}
                          className="w-full lg:w-[48%] self-stretch"
                        >
                          <JobCard job={data} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <h5 className="mt-2 mb-1">Sorry! No Bookings Found</h5>
                  )}

                  <div className="flex gap-4 items-center justify-end my-4 px-4">
                    {hasNextPage && (
                      <button
                        className=" text-custom-500"
                        onClick={() => handleEndReached()}
                      >
                        Load more
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Jobs;
